module.exports = __webpack_public_path__ + "img/clouds.5b854d11.svg";